const hazardHierarchy = [
  { id: 1, value: 'Eliminate' },
  { id: 2, value: 'Substitute' },
  { id: 3, value: 'Isolate' },
  { id: 4, value: 'Engineering' },
  { id: 5, value: 'Admin' },
  { id: 6, value: 'PPE' }
];

export default { hazardHierarchy };
